export default __webpack_public_path__ + "c89abae4d7daa0ab3b0d856dc9c08dd0.png";